<template>
  <div
    class="item-list"
    :class="[{ selected, headless }, item.getCategory()]"
    @contextmenu.stop
    :style="coloring"
  >
    <ItemHeader v-if="!headless" class="list-header" :itemID="itemID" />
    <div class="separator" />
    <DraggableList :parent="item" :elements="children" compType="card" />
    <AddItem :targetID="itemID" />
  </div>
</template>

<style scoped>
.item-list {
  margin: var(--basic-margin);
  padding: var(--basic-padding);
  border-radius: var(--rounding-larger);

  display: flex;
  flex-direction: column;

  height: fit-content;
  width: 400px;
  min-width: 250px;
  max-width: 80vw;
  @media (min-width: 500px) {
    width: 280px;
    max-width: 400px;
  }
  @media (min-width: 1000px) {
    width: 320px;
  }
  @media (min-width: 1400px) {
    width: 360px;
  }
  @media (min-width: 1600px) {
    width: 400px;
  }
}
.main-panel .item-list.singleList {
  width: 540px;
  max-width: 90vw;
}
.item-list.list-like {
  background-color: var(--bg-color-list);
  padding: var(--basic-padding);
  gap: var(--basic-gap);
  border: var(--list-border);
  & .separator {
    display: none;
  }
}
.item-list.task-like {
  background-color: var(--bg-color-card-default);
  padding: calc(var(--basic-padding) - 1px);
  border: var(--task-border);
  gap: 0px;
  & .elements {
    gap: 0;
    &::v-deep .card {
      border-bottom: 1px solid var(--bg-color-main);
      border-radius: 0;
    }
  }
  & .separator {
    width: 100%;
    margin: 4px 0;
    border-top: var(--task-header-underline);
  }
}

.item-list.date-like {
  & .separator {
    width: 100%;
    margin-bottom: 4px;
    margin-top: -4px;
    border-top: var(--date-header-underline);
  }
  &::v-deep .card {
    border: var(--task-border);
  }
}

.item-list.headless {
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: none;
}

.item-list .elements {
  gap: calc(2 * var(--basic-gap));
}

.item-list.task-like.selected,
.item-list.list-like.selected {
  outline: var(--selection-border);
  outline-offset: -2px;
}
</style>

<script>
import ItemHeader from "./ItemHeader.vue";
import selection from "../selection";
import AddItem from "./AddItem.vue";
import SortableList from "./SortableList.vue";
import { getItem } from "../reactive-cache";
import { ORDINARY_TYPES, REL_ELEM } from "@/structure";
import DraggableList from "./DraggableList.vue";

export default {
  name: "ItemList",
  props: ["itemID", "headless", "childFilter"],
  components: {
    ItemHeader,
    AddItem,
    SortableList,
    DraggableList,
  },
  computed: {
    item() {
      return getItem(this.itemID);
    },
    selected() {
      return selection.has(this.item);
    },
    children() {
      switch (this.childFilter) {
        case "taskLike":
          return this.item.getTaskLikeChildren();
        case "listLike":
          return this.item.getListLikeChildren();
        default:
          return this.item.getChildren();
      }
    },
    coloring() {
      if (!ORDINARY_TYPES.includes(this.item.type)) {
        return "";
      }
      let item = this.item;
      while (item) {
        if (item.color) {
          return "background-color: var(--card-color-" + item.color + ");";
        }
        item = item.getParent(REL_ELEM);
      }
      return "";
    },
  },
  methods: {},
};
</script>
